import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Table } from '@material-ui/core';
import { api } from 'src/Api';
import { Link as RouterLink } from 'react-router-dom';
import ListDocument from 'src/components/home/ListDocument';
import Searchbar from 'src/components/SearchBar';

export default function CustomerList() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { service_id, service_name, sub_service_id, sub_service_name, is_pickup } =
    location.state || {};

  const [deletemodal, setDeleteModal] = useState(false);
  const [subServiceId, setSubServiceId] = useState('');
  const [loading, setloading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [pagesCount, setPagesCount] = useState(1);
  const [page, setPage] = useState(1);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [customerListId, setCustomerListId] = useState('');
  const [showDocument, setShowDocument] = useState(false);
  const [search, setsearch] = useState('');
  const [serachloading, setsearchloading] = useState(false);
  const handleDeleteModal = () => {
    setDeleteModal(false);
    setSubServiceId('');
  };

  useEffect(() => {
    HandleGetCustomers(1);
  }, []);

  const HandleGetCustomers = (pages, value) => {
    console.log('search ', search);
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('status', 'Active');
    formData.append('service_id', service_id);
    formData.append('sub_service_id', sub_service_id);
    formData.append('page', pages);
    search && formData.append('search', value ? '' : search);
    fetch(api.get_service_details, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setCustomerData(result.data);
          setPagesCount(Math.ceil(result.count / 10));
          setsearchloading(false);
        } else {
          console.log('Error:', result.message);
          setsearchloading(false);
        }
        setloading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
        setloading(false);
        setsearchloading(false);
      });
  };

  const handleDeleteCustomer = () => {
    setDeleteLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    subServiceId && formData.append('id', subServiceId);

    fetch(api.delete_customer_service, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          customerData.length = 0;
          setPage(1);
          HandleGetCustomers(1);
          handleDeleteModal();
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
        }
        setDeleteLoading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
        setDeleteLoading(false);
      });
  };

  const handleSendLink = (id) => {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    id && formData.append('id', id);

    fetch(api.send_service_link, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
        }
      })
      .catch((error) => {
        console.log('Fetch error:', error);
      });
  };

  const handlesubservicemodalDelete = (id, name) => {
    setSubServiceId(id);
    setDeleteModal(true);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    HandleGetCustomers(value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleOpenDocumentList = (id) => {
    setCustomerListId(id);
    setShowDocument(true);
  };

  const handleCloseDocumentList = () => {
    setCustomerListId('');
    setShowDocument(false);
  };
  console.log('customersdata======', search);
  return (
    <Page title={`Customers | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack alignItems={'center'}>
            <Stack direction="row">
              <IconButton
                style={{
                  marginRight: 12,
                  height: 40,
                  width: 70,
                  borderRadius: 5,
                  backgroundColor: 'rgba(249, 0, 1,0.1)'
                }}
                onClick={() => navigate(-1)}
              >
                <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
              </IconButton>

              <div style={{ width: '100%' }}>
                <Typography variant="h4" sx={{ color: '#f90001' }}>
                  Customers
                </Typography>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}
                >
                  <Typography sx={{ color: '#000000', fontSize: 11 }}>Service Name:</Typography>
                  <Typography
                    sx={{
                      color: '#f90001',
                      fontSize: 11,
                      // textDecoration: 'underline',
                      fontWeight: 'bold',
                      marginLeft: 0.5
                    }}
                  >
                    {service_name}
                  </Typography>
                </div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}
                >
                  <Typography sx={{ color: '#000000', fontSize: 11 }}>Sub Service Name:</Typography>
                  <Typography
                    sx={{
                      color: '#f90001',
                      fontSize: 11,
                      fontWeight: 'bold',
                      marginLeft: 0.5
                    }}
                  >
                    {sub_service_name}
                  </Typography>
                </div>
              </div>
            </Stack>
          </Stack>

          <Stack>
            <Button
              variant="contained"
              sx={{ alignSelf: 'end', fontSize: 11 }}
              component={RouterLink}
              to="/dashboard/services/sub_services/customer_list/add_customers"
              state={{
                service_id: service_id,
                sub_service_id: sub_service_id,
                is_pickup: is_pickup
              }}
            >
              Add Customer
            </Button>
          </Stack>
        </Stack>

        <Dialog open={deletemodal} onClose={handleDeleteModal}>
          <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteModal} color="primary">
              No
            </Button>
            <LoadingButton
              loading={deleteLoading}
              variant="contained"
              onClick={handleDeleteCustomer}
              color="primary"
              autoFocus
            >
              Yes
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Modal
          open={showDocument}
          onClose={handleCloseDocumentList}
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          style={{
            display: 'flex',
            height: '100%',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{
              width: '65%',
              maxHeight: '90%',
              minHeight: '40%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              padding: 2,
              border: '2px solid',
              borderColor: '#f00001',
              borderRadius: 0.5
            }}
          >
            <ListDocument docid={customerListId} onClose={handleCloseDocumentList} />
          </Box>
        </Modal>

        <Box
          mt={2}
          // p={2}
          style={{
            flexDirection: 'row',
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between'
          }}
          className="top_options"
        >
          <Searchbar
            width={'90%'}
            value={search}
            setFunction={(val) => {
              setsearch(val);
            }}
            onClickSearch={() => {
              setsearch('');

              customerData.length = 0;
              console.log('cross pr function work kr raha ha');
              setPage(1);
              HandleGetCustomers(1, 'null');
            }}
            placeholder="Search"
            onEnter={() => {
              setsearchloading(true);
              setPage(1);
              HandleGetCustomers(1);
            }}
          />
          <LoadingButton
            style={{ width: '15%', marginLeft: '2.5%' }}
            // loading={serachloading}
            variant="contained"
            onClick={() => {
              setsearchloading(true);
              customerData.length = 0;
              setPage(1);
              HandleGetCustomers(1);
            }}
            className="width_full"
          >
            <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
          </LoadingButton>
        </Box>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2, minWidth: 800 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#f00001', width: 300 }}>
                  Customer Name
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Customer Email</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Contact</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}></TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Action</TableCell>
              </TableRow>
            </TableHead>

            {!loading && customerData?.length !== 0 && (
              <TableBody>
                {customerData?.map((item, index) => (
                  <TableRow>
                    <TableCell scope="row" padding="normal" style={{ width: 150 }}>
                      <Stack direction="row" alignItems="center" spacing={1} style={{ width: 150 }}>
                        <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                          <Typography variant="subtitle2" flexWrap={'wrap'}>
                            {item.customer_name === 'undefined' ? 'N/A' : item.customer_name}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>

                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>{item?.email || '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>{item?.contact || '-'}</Typography>
                    </TableCell>
                    <TableCell>
                      {item?.is_customer_started && (
                        <Box
                          style={{
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            borderRadius: 20,
                            height: 20,
                            width: 105,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <Box
                            style={{
                              width: 10,
                              height: 10,
                              borderRadius: 5,
                              backgroundColor: '#4CAF50',
                              marginRight: 8
                            }}
                          />
                          <Typography
                            style={{
                              color: '#fff',
                              fontSize: 11,
                              fontWeight: 'bold'
                            }}
                          >
                            Live Tracking
                          </Typography>
                        </Box>
                      )}
                    </TableCell>

                    <TableCell align="center" style={{ width: 100 }}>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Edit">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            component={RouterLink}
                            to="/dashboard/services/sub_services/customer_list/add_customers"
                            state={{
                              service_id: service_id,
                              sub_service_id: sub_service_id,
                              item: item,
                              is_pickup: is_pickup
                            }}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 16, color: '#ffffff' }}
                              icon="icon-park-outline:edit"
                            />
                          </LoadingButton>
                        </Tooltip>

                        <Tooltip title="Tracking">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            component={RouterLink}
                            to="/dashboard/services/sub_services/customer_list/tracking"
                            state={{
                              service_id: service_id,
                              service_name: service_name,
                              sub_service_id: sub_service_id,
                              sub_service_name: sub_service_name,
                              customer_name: item?.customer_name,
                              customer_id: item?.id
                            }}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 16, color: '#ffffff' }}
                              icon="ic:outline-my-location"
                            />
                          </LoadingButton>
                        </Tooltip>

                        {/* MAP */}
                        {service_name === 'Moving' && (
                          <Tooltip title="Map">
                            <LoadingButton
                              size="small"
                              variant="contained"
                              style={{
                                justifyContent: 'center',
                                width: 30,
                                height: 30,
                                minWidth: 30,
                                padding: 0,
                                lineHeight: 1,
                                alignSelf: 'center'
                              }}
                              component={RouterLink}
                              to="/dashboard/services/sub_services/customer_list/map"
                              state={{
                                data: item
                              }}
                            >
                              <Iconify
                                style={{ cursor: 'pointer', fontSize: 16, color: '#ffffff' }}
                                icon="at-icons:map"
                              />
                            </LoadingButton>
                          </Tooltip>
                        )}

                        <Tooltip title="Messages">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            component={RouterLink}
                            to="/dashboard/services/sub_services/customer_list/message"
                            state={{
                              service_id: service_id,
                              service_name: service_name,
                              sub_service_id: sub_service_id,
                              sub_service_name: sub_service_name,
                              customer_id: item?.id
                            }}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                              icon="ic:outline-message"
                            />
                          </LoadingButton>
                        </Tooltip>
                        <Tooltip title="Document">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            // onClick={() => handleOpenDocumentList(item?.id)}
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            // to="#"
                            component={RouterLink}
                            to="/dashboard/services/sub_services/customer_list/Document"
                            state={{
                              docid: item.id,
                              service_id: service_id,
                              sub_service_id: sub_service_id
                            }}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                              icon="heroicons-outline:document-add"
                            />
                          </LoadingButton>
                        </Tooltip>

                        <Tooltip title="Send Link">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            to="#"
                            onClick={() => handleSendLink(item?.id)}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 16, color: '#ffffff' }}
                              icon="mdi:external-link"
                            />
                          </LoadingButton>
                        </Tooltip>

                        <Tooltip title="Delete">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            onClick={() => handlesubservicemodalDelete(item?.id)}
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            to="#"
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                              icon="mingcute:delete-2-line"
                            />
                          </LoadingButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={4} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {customerData?.length == 0 && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={4} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography variant="h6" gutterBottom color={'#f90001'}>
                        Customers not found!
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && customerData?.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}
        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
